// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const settingOutOptionsDefault = [];

export const SettingOut = zod.object({
  "default": zod.unknown(),
  "description": zod.string(),
  "key": zod.string(),
  "label": zod.string(),
  "options": zod.array(zod.string()).default(settingOutOptionsDefault),
  "type": zod.enum(['text', 'number', 'boolean', 'select']),
  "value": zod.unknown()
});

export type SettingOut = zod.input<typeof SettingOut>;
export type SettingOutOutput = zod.output<typeof SettingOut>;
